import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { ComponentBase } from 'src/app/components/core/_infrastructure/classes/componentBase';
import { ExceptionManager } from 'src/app/components/core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from 'src/app/components/core/_infrastructure/classes/services/auth.service';
import { NotificationService } from 'src/app/components/core/_infrastructure/classes/services/notification.service';
import { TransicionEstadoUdInspeccionCamService } from '../transicionestadoudinspeccioncam.service';
import { TransicionEstadoUdInspeccionCamViewModel } from '../transicionestadoudinspeccioncam.types';
import { GlobalService } from '../../../../core/_infrastructure/classes/services/global.service';
import { CampaniasGlobalService } from '../../../../_campanias/services/global-campanias.service';
import { EnumIdsTcPerfilUsuario } from '../../../../_importacion/solicitudes/types/enum';
import { Tc } from '../../../../core/_infrastructure/types/common';

@Component({
    selector: 'app-transicionestadoudinspeccioncam-wrapper-edit',
    templateUrl: './transicionestadoudinspeccioncam-wrapper-edit.component.html',
})
export class TransicionEstadoUdInspeccionCamWrapperEditComponent extends ComponentBase implements OnInit {
    visibilitySpinner = false;
    transicionEstadoUdInspeccionCam: TransicionEstadoUdInspeccionCamViewModel;
    formGroup: FormGroup;

    listPerfilesUsuario: Tc[];
    listTiposInspeccionCam: Tc[];
    listEstadosUnidadInspeccionCam: Tc[];
    listResultadosInspeccionCam: Tc[];

    messageErrorAlreadyExist = 'Ya existe esta transición de estados para la Unidad de Inspección de Campañas';
    successMessage = 'Transición de estados para la Unidad de Inspección de Campañas guardada correctamente';
    listUrl = '/mantenimiento/general/transicionestadoudinspeccioncam';

    activatedRoute$ = this.activatedRoute.paramMap.subscribe(params => {
        const id: any = params.get('id');
        if (id) {
            this.getTransicionEstadoUdInspeccionCam(id);
        }
    });

    constructor(
        private fb: FormBuilder,
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private transicionEstadoUdInspeccionCamService: TransicionEstadoUdInspeccionCamService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private globalService: GlobalService,
        private campaniasGlobalService: CampaniasGlobalService,
    ) {
        super(authService, notificationService, exceptionHandler);
    }

    private getListas(): void {
        this.getResultadosInspeccionCam();
        this.getEstadosUnidadInspeccionCam();
        this.getTiposInspeccionCam();
        this.getPerfilesUsuario();
    }

    private getTiposInspeccionCam(): void {
        this.globalService.getTiposInspeccionCam().subscribe(res => {
            this.listTiposInspeccionCam = res;
        });
    }

    private getEstadosUnidadInspeccionCam(): void {
        this.campaniasGlobalService.getEstadosUnidadInspeccion().subscribe(res => {
            this.listEstadosUnidadInspeccionCam = res;
        });
    }

    private getResultadosInspeccionCam(): void {
        this.campaniasGlobalService.getListaResultadosInspeccionCam().subscribe(res => {
            this.listResultadosInspeccionCam = res;
        });
    }

    private getPerfilesUsuario(): void {
        this.globalService.getPerfilesUsuario().subscribe((listPerfilesUsuario: Tc[]) => {
            this.listPerfilesUsuario = listPerfilesUsuario?.filter(
                listPerfilesUsuario =>
                    listPerfilesUsuario.Id === EnumIdsTcPerfilUsuario.ID_ADMINISTRADOR ||
                    listPerfilesUsuario.Id === EnumIdsTcPerfilUsuario.ID_ENTIDAD_AUDITORA ||
                    listPerfilesUsuario.Id === EnumIdsTcPerfilUsuario.ID_COMUNIDAD_AUTONOMA,
            );
        });
    }

    ngOnInit(): void {
        this.getListas();
        this.preparePresentation();
    }

    private preparePresentation(): void {
        this.buildForm();
    }

    private buildForm(): void {
        this.formGroup = this.fb.group({
            basic: this.fb.group({
                Id: [null],
                IdResultadoInspeccionCam: [null, Validators.required],
                IdEstadoUnidadInspeccionCam: [null, Validators.required],
                IdTipoInspeccionCam: [null, Validators.required],
                IdPerfilUsuario: [null, Validators.required],
                IdSiguienteEstadoUnidadInspeccionCam: [null, Validators.required],
            }),
        });
    }

    private getTransicionEstadoUdInspeccionCam(id: number): void {
        this.transicionEstadoUdInspeccionCamService
            .getTransicionEstadoUdInspeccionCam(id)
            .pipe(
                tap((t: TransicionEstadoUdInspeccionCamViewModel) => {
                    this.transicionEstadoUdInspeccionCam = t;
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    this.formGroup.disable();
                    return of([]);
                }),
            )
            .subscribe();
    }

    onSave(): void {
        this.visibilitySpinner = true;
        const model = { ...this.formGroup.value.basic };

        this.transicionEstadoUdInspeccionCamService
            .saveTransicionEstadoUdInspeccionCam(model)
            .pipe(
                tap(res => {
                    this.visibilitySpinner = false;
                    this.addSuccessMessage(this.successMessage);
                    this.onBack();
                }),
                catchError(error => {
                    this.catchServerError(error);
                    this.visibilitySpinner = false;
                    if (error?.message?.indexOf(this.messageErrorAlreadyExist) != -1) {
                        this.formGroup.disable();
                    }
                    return of([]);
                }),
            )
            .subscribe();
    }

    onBack(): void {
        this.router.navigate([this.listUrl]);
    }

    get formInvalid(): boolean {
        return !this.formGroup.valid || !this.formGroup.dirty || this.formGroup.pristine;
    }
}
